import BackedEnum from '@/enums/BackedEnum';

export default class SearchType extends BackedEnum {}

SearchType.AdvancedSearch = 'ADVANCED_SEARCH';
SearchType.City = 'CITY';
SearchType.CityArticles = 'CITY_ARTICLES';
SearchType.Condition = 'CONDITION';
SearchType.Glossary = 'GLOSSARY';
SearchType.GuidedSearch = 'GUIDED_SEARCH';
SearchType.GuidedSearchFallback = 'GUIDED_SEARCH_FALLBACK';
SearchType.PetConnectionArticles = 'PET_CONNECTION_ARTICLES';
SearchType.Symptom = 'SYMPTOM';
SearchType.TransferSearch = 'TRANSFER_SEARCH';
